import { BulletList, Callout } from "../components";
import { Col } from "../lib";

export function ContactScreen() {
  return (
    <Callout
      icon="face-agent"
      title="Customer Support"
      message="In case of any problem, try to reach out via one of these channels"
    >
      <Col mt="8">
        <BulletList
          content={["Email: contact@smooci.com", "Telegram: @SmoociSammy"]}
        />
      </Col>
    </Callout>
  );
}
